
import {
  Box,
  HStack,
  Link,
  Text,
  Divider,
  useBreakpointValue,
  Wrap,
  WrapItem
} from "@chakra-ui/react";

import React from "react";

const StudentFooterLayout = () => {

   const showFooter = useBreakpointValue({
    base: false,
    md: true
  }); 
// const showFooter = true;
  return (
    <Box>

      {showFooter && (

      <Box
        as="footer"
        position="fixed"
        bottom="0"
        left="0"
        h="25px"
        w="100%"
        bg="gray.600"
        color="gray.100"
        borderTop="1px solid"
        borderColor="gray.600"
        px={6}
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex={15}
      >
          <Wrap
            justify="center"
            spacing={4}
            align="center"
            fontSize="sm"
          >

            <WrapItem>
              <Text>
                © 2025 Eduvic Technologies
              </Text>
            </WrapItem>

            <WrapItem>
              <Divider
                orientation="vertical"
                h="16px"
                borderColor="gray.500"
              />
            </WrapItem>

            <WrapItem>
              <Text>
                Eduvic Practice Platform
              </Text>
            </WrapItem>

            <WrapItem>
              <Divider
                orientation="vertical"
                h="16px"
                borderColor="gray.500"
              />
            </WrapItem>

            <WrapItem>
              <Link
                href="/practice/terms"
                _hover={{
                  color: "white",
                  textDecoration: "none"
                }}
              >
                Terms
              </Link>
            </WrapItem>

            <WrapItem>
              <Divider
                orientation="vertical"
                h="16px"
                borderColor="gray.500"
              />
            </WrapItem>

            <WrapItem>
              <Link
                href="/practice/privacy"
                _hover={{
                  color: "white",
                  textDecoration: "none"
                }}
              >
                Privacy
              </Link>
            </WrapItem>

            <WrapItem>
              <Divider
                orientation="vertical"
                h="16px"
                borderColor="gray.500"
              />
            </WrapItem>

            <WrapItem>
              <Link
                href="/practice/app/support"
                _hover={{
                  color: "white",
                  textDecoration: "none"
                }}
              >
                Support
              </Link>
            </WrapItem>

          </Wrap>

        </Box>

      )}

    </Box>
  );
};

export default StudentFooterLayout;

